import { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';

import { Col, Form, Row } from 'react-bootstrap';
import AlertService from '../../../../../../../components/SweetAlert';
import ToastUtil from '../../../../../../../components/ToastNotification/ToastUtil';
import { config } from '../../../../../../../config/index';
import { PUT, newFetch } from '../../../../../../../helpers/fetch';
import LayoutContext from '../../../../../../../store/Layout/contexts';
const { API_URL } = config;

const EditClientUser = ({
  history,
  clientId,
  setActiveUserTabPage,
  selectedUser,
  setActiveTab,
}) => {
  const user_id = selectedUser;

  const [clientUser, setClientUser] = useState({});
  const [name, setName] = useState('');
  const [lastName, setLastName] = useState('');
  const [employeeNo, setEmployeeNo] = useState('');
  const [designation, setDesignation] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [clients, setClients] = useState('');

  const nameHandler = (e) => setName(e.target.value);
  const lastNameHandler = (e) => setLastName(e.target.value);
  const employeeNoHandler = (e) => setEmployeeNo(e.target.value);
  const designationHandler = (e) => setDesignation(e.target.value);
  const emailHandler = (e) => setEmail(e.target.value);

  const [validated, setValidated] = useState(false);

  const discardHandler = async () => {
    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to discard all changes?'
      )
    ) {
      // setLastName('')
      // setEmployeeNo('')
      // setDesignation('')
      // setGender(0)
      // setRace(0)
      // setDateOfBirth('')
      // setEmail('')
      setName(clientUser.first_name);
      setLastName(clientUser.last_name);
      setEmployeeNo(clientUser.employee_no);
      setDesignation(clientUser.designation);
      setEmail(clientUser.email);
    }
  };

  const handleSubmit = async (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      await submitHandler(event);
    }

    setValidated(true);
  };

  const submitHandler = async (event) => {
    event.preventDefault();

    const data = {
      first_name: name,
      designation,
    };

    let url = `${API_URL}/client/users/${user_id}`;
    let token = localStorage.getItem('token');

    try {
      let response = await fetch(url, {
        method: 'PUT',
        body: JSON.stringify(data),
        withCredentials: true,
        mode: 'cors',
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      let responseData = await response.json();

      if (responseData.success) {
        ToastUtil.success(responseData.message);
        setActiveTab('users');
        setActiveUserTabPage('list');
      } else {
        ToastUtil.error(responseData.message);
      }
    } catch (error) {
      ToastUtil.error(error);
    }
  };

  const deactivateHandler = async (id) => {
    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to deactivate this user?'
      )
    ) {
      let api_path = `/client/users/${id}/activation/deactivate`;
      let response = await newFetch(PUT, api_path);
      ToastUtil.success(response.message);
      response.success && setActiveTab('users');
      setActiveUserTabPage('list');
    }
  };

  const activateHandler = async (id) => {
    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to activate this user?'
      )
    ) {
      let api_path = `/client/users/${id}/activation/activate`;
      let response = await newFetch(PUT, api_path);
      ToastUtil.success(response.message);
      response.success && setActiveTab('users');
      setActiveUserTabPage('list');
    }
  };

  const changeTypeHandler = async (id) => {
    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to set this as Admin User?'
      )
    ) {
      let api_path = `/client/users/${id}/change/type`;
      let response = await newFetch(PUT, api_path);
      ToastUtil.success(response.message);
      response.success && setActiveTab('users');
      setActiveUserTabPage('list');
    }
  };

  useEffect(() => {
    const fetchClientUser = async () => {
      try {
        let url = `${API_URL}/client/users/${user_id}`;
        let token = localStorage.getItem('token');

        let response = await fetch(url, {
          mode: 'cors',
          method: 'GET',
          withCredentials: true,
          headers: {
            Authorization: token,
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json; charset=utf-8',
          },
        });

        if (response.ok) {
          let data = await response.json();
          let userData = data.data;

          setClientUser(userData);
          setName(userData.first_name);
          setLastName(userData.last_name);
          setEmployeeNo(userData.employee_no);
          setDesignation(userData.designation);
          setEmail(userData.email);
        } else {
          console.log(response.message);
        }
      } catch (error) {
        console.log(error);
      }
    };

    fetchClientUser();
  }, []);

  return (
    <LayoutContext.Consumer>
      {({ activeSidebar }) => (
        <div style={{ paddingTop: '3rem' }}>
          <div
            className="d-flex flex-column"
            style={{ paddingLeft: '3rem', paddingRight: '3rem' }}
          >
            <NavLink
              to={`/clients/client/${clientId}`}
              className="text-decoration-none"
              style={{ color: 'inherit' }}
              onClick={(e) => {
                e.preventDefault();
                setActiveUserTabPage('list');
              }}
            >
              <div style={{ color: '#0d6efd' }}>
                <i className="fas fa-chevron-left pe-2"></i> User Management
              </div>
            </NavLink>
            <div className="pt-4">
              <h5>Edit User</h5>
            </div>
          </div>
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <div
              style={{
                marginTop: '1rem',
                paddingLeft: '3rem',
                paddingRight: '3rem',
              }}
            >
              <div className="d-flex border rounded">
                <div
                  className="flex-grow-1 bg-white"
                  style={{ padding: '2.25rem' }}
                >
                  <Row className="mb-3">
                    <Form.Group as={Col} md="6">
                      <Form.Label>
                        <strong>Name*</strong>
                      </Form.Label>
                      <Form.Control
                        required
                        type="text"
                        name="name"
                        value={name}
                        placeholder="name"
                        onChange={(e) => nameHandler(e)}
                        maxLength={60}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please enter Name.
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} md="6">
                      <Form.Label>
                        <strong>Position*</strong>
                      </Form.Label>
                      <Form.Control
                        required
                        name="designation"
                        value={designation}
                        type="text"
                        placeholder="Position"
                        onChange={(e) => designationHandler(e)}
                        maxLength={60}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please enter position.
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row>
                  <Row className="mb-3">
                    <Form.Group as={Col} md="6">
                      <Form.Label>
                        <strong>Email*</strong>
                      </Form.Label>
                      <Form.Control
                        value={email}
                        type="email"
                        placeholder="Email"
                        onChange={(e) => emailHandler(e)}
                        maxLength={100}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please enter valid email.
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} md="6">
                      <Form.Label>
                        <strong>Password*</strong>
                      </Form.Label>
                      <Form.Control
                        required
                        type="password"
                        placeholder="Password"
                        maxLength={50}
                      />
                    </Form.Group>
                  </Row>
                </div>
              </div>
            </div>
            <div
              style={{
                marginTop: '2rem',
                paddingLeft: '3rem',
                paddingRight: '3rem',
                paddingBottom: '6rem',
              }}
            >
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex">
                  {clientUser.active ? (
                    <button
                      type="button"
                      onClick={() => deactivateHandler(clientUser.id)}
                      className="btn btn-outline-danger align-items-start adjust-fs adjust-shadow mx-2"
                      style={{ width: '9rem' }}
                    >
                      Deactivate User
                    </button>
                  ) : (
                    <button
                      type="button"
                      onClick={() => activateHandler(clientUser.id)}
                      className="btn btn-outline-success align-items-start adjust-fs adjust-shadow mx-2"
                      style={{ width: '9rem' }}
                    >
                      Activate User
                    </button>
                  )}

                  <button
                    type="button"
                    onClick={() => changeTypeHandler(clientUser.id)}
                    className="btn btn-outline-brand adjust-fs adjust-shadow"
                    style={{ width: '9rem' }}
                  >
                    Set as Admin User
                  </button>
                </div>

                <div className="d-flex">
                  <button
                    type="button"
                    className="btn btn-outline-brand adjust-fs adjust-shadow"
                    style={{ width: '7rem' }}
                    onClick={discardHandler}
                  >
                    Discard
                  </button>
                  <button
                    type="submit"
                    className="btn btn-brand ms-3 adjust-fs adjust-shadow"
                    style={{ width: '7rem' }}
                  >
                    Save changes
                  </button>
                </div>
              </div>
            </div>
          </Form>
        </div>
      )}
    </LayoutContext.Consumer>
  );
};

export default EditClientUser;
